import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%", // Adjust width to be responsive
  maxHeight: "80vh", // Adjust max height to be responsive
  overflowY: "scroll",
  scrollBehavior: "smooth",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function CNResponseView({ open, setOpen, data }) {
  const handleClose = () => setOpen(false);
  const [response, setResponse] = React.useState([]);

  React.useEffect(() => {
    try {
      let json_object = data.cn_response.replace(/'/g, '"');
      console.log(json_object);

      setResponse(JSON.parse(json_object).message);
    } catch {
      setResponse([{ Response: { STATUS: `${data.cn_response}` } }]);
    }
  }, [data]);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Credit Note Response
            <br />
            <i>AUSHADHAI NUMBER</i>{" "}
            {data.stockists_master_id.toString().padStart(10, "0")}
          </Typography>
          {response &&
            response.map((item, index) => {
              const key = Object.keys(item)[0];
              const status = item[key]?.Response?.STATUS;
              return (
                <div key={index}>
                  <p>{status ? status : `${data.cn_response}`}</p>
                </div>
              );
            })}
        </Box>
      </Modal>
    </div>
  );
}
